import React, { useEffect, useMemo, useRef, useState } from "react";

interface Project {
  id: string;
  title: string;
  description: string;
  fullDescription: string;
  image: string;
  technologies: string[];
  link: string;
}

const ProjectsSection: React.FC = () => {
  const sectionRef = useRef<HTMLElement | null>(null);
  const expandedCardRef = useRef<HTMLDivElement | null>(null);
  const [expandedProject, setExpandedProject] = useState<string | null>(null);
  const [isMobile, setIsMobile] = useState<boolean>(
    typeof window !== "undefined" ? window.innerWidth < 640 : false,
  );

  const projects: Project[] = useMemo(
    () => [
      {
        id: "01",
        title: "Tienda Online",
        description:
          "Plataforma e-commerce con carrito de compras y pagos integrados.",
        fullDescription:
          "Plataforma e-commerce completa para usuarios y administradores, con compras en línea, gestión de inventario, comprobantes de pago, notificaciones y configuración.",
        image:
          "https://res.cloudinary.com/xvzxvfee/image/upload/v1788743193/onlineshop_cpty9g.webp",
        technologies: ["React", "Node.js", "MongoDB", "Stripe"],
        link: "https://demo-shop.sprintcore.ec/",
      },
      {
        id: "02",
        title: "Gestión de Archivos",
        description:
          "Aplicación web para organizar, subir y compartir archivos en la nube.",
        fullDescription:
          "Aplicación de gestión de archivos con funcionalidades de subida, organización en carpetas, búsqueda avanzada y compartición segura.",
        image:
          "https://res.cloudinary.com/xvzxvfee/image/upload/v1788743193/cloudocs_nwheop.webp",
        technologies: ["React Native", "Firebase", "Redux"],
        link: "https://demo-files.sprintcore.ec/",
      },
      {
        id: "03",
        title: "Aplicación de Discoteca",
        description:
          "Aplicación móvil para reservas, eventos y promociones de una discoteca.",
        fullDescription:
          "Aplicación móvil para discoteca con sistema de reservas, calendario de eventos, promociones exclusivas, tienda virtual, interacción con el DJ, notificaciones push y más.",
        image:
          "https://res.cloudinary.com/xvzxvfee/image/upload/v1788743193/nyxsocial_ijvnub.webp",
        technologies: ["Next.js", "Tailwind CSS", "WordPress REST API"],
        link: "https://nyxsocial.app/",
      },
      {
        id: "04",
        title: "Repuestos Automotrices",
        description:
          "Landing page moderna para la presentación de repuestos y servicios automotrices.",
        fullDescription:
          "Landing page moderna y atractiva para una empresa de repuestos automotrices, con diseño responsivo, productos destacados, testimonios y formulario de contacto.",
        image:
          "https://res.cloudinary.com/xvzxvfee/image/upload/v1788743189/orvilweb2_yeemvk.webp",
        technologies: ["Vue.js", "Laravel", "MySQL", "AWS"],
        link: "https://demo-autorepuestos.sprintcore.ec/",
      },
      {
        id: "05",
        title: "Gestión de Sedes Deportivas",
        description:
          "Aplicación web y móvil para la gestión integral de sedes deportivas.",
        fullDescription:
          "Aplicación web para la administración y aplicación móvil para clientes de sedes deportivas, con inscripciones, calendario de eventos, panel administrativo con métricas y visualización de datos en vivo de partidos.",
        image:
          "https://res.cloudinary.com/xvzxvfee/image/upload/v1788743189/futapp_dpygso.webp",
        technologies: ["React", "D3.js", "Python", "GraphQL"],
        link: "https://demo-futbol-admin.sprintcore.ec/",
      },
      {
        id: "06",
        title: "Sistema Clínico",
        description:
          "Aplicación web para la gestión de citas, pacientes, consultas e historiales clínicos.",
        fullDescription:
          "Aplicación web para la gestión de clínicas, con funcionalidades de registro de pacientes, historial clínico, programación de citas, gestión de consultas y panel administrativo con métricas y visualización de datos.",
        image:
          "https://res.cloudinary.com/xvzxvfee/image/upload/v1788743190/docapp_fyhhek.webp",
        technologies: ["Flutter", "Node.js", "MongoDB", "Google Maps API"],
        link: "https://demo-clinica.sprintcore.ec/",
      },

      // NUEVOS PROYECTOS

      {
        id: "07",
        title: "Plataforma PDDD",
        description:
          "Plataforma web del Programa de Defensa de Defensores y Defensoras Indígenas de la Amazonía.",
        fullDescription:
          "Plataforma web desarrollada para el Programa de Defensa de Defensores y Defensoras Indígenas (PDDD), orientada a comunicar sus acciones, objetivos, recursos e información estratégica para la protección y fortalecimiento de los derechos de los pueblos indígenas amazónicos.",
        image:
          "https://res.cloudinary.com/xvzxvfee/image/upload/v1788743190/pdddweb_vvwpia.webp",
        technologies: ["React", "Vite", "Tailwind CSS"],
        link: "https://pddd.coicamazonia.org/",
      },
      {
        id: "08",
        title: "Escuela Evaristo Nugkuag",
        description:
          "Plataforma educativa virtual orientada a la formación de los pueblos indígenas amazónicos.",
        fullDescription:
          "Entorno virtual de aprendizaje de la Escuela Evaristo Nugkuag, desarrollado sobre Moodle para gestionar cursos, contenidos educativos, recursos, actividades, evaluaciones y procesos de formación dirigidos a organizaciones y pueblos indígenas de la Cuenca Amazónica.",
        image:
          "https://res.cloudinary.com/xvzxvfee/image/upload/v1788743197/moodleweb_rqkgmd.webp",
        technologies: ["Moodle", "PHP", "MariaDB"],
        link: "https://nugkuag.coicamazonia.org/",
      },
      {
        id: "09",
        title: "Prime Shell Store",
        description:
          "Tienda online de calzado con catálogo digital y experiencia de compra moderna.",
        fullDescription:
          "Plataforma e-commerce especializada en la venta de calzado, diseñada con una experiencia visual moderna y responsiva para presentar productos, colecciones y características de cada modelo, facilitando la navegación y el proceso de compra desde diferentes dispositivos.",
        image:
          "https://res.cloudinary.com/xvzxvfee/image/upload/v1788743190/primeshellweb_vgpr6q.webp",
        technologies: ["React", "Vite", "Tailwind CSS"],
        link: "https://primeshellstore.com/",
      },
    ],
    [],
  );

  useEffect(() => {
    const update = () => {
      setIsMobile(window.innerWidth < 640);
    };

    update();
    window.addEventListener("resize", update);

    return () => {
      window.removeEventListener("resize", update);
    };
  }, []);

  useEffect(() => {
    if (!expandedProject) return;

    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Node;

      if (
        expandedCardRef.current &&
        !expandedCardRef.current.contains(target)
      ) {
        setExpandedProject(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [expandedProject]);

  const toggleProject = (id: string) => {
    setExpandedProject((prev) => (prev === id ? null : id));
  };

  const smoothEase = "cubic-bezier(0.22, 1, 0.36, 1)";
  const softEase = "cubic-bezier(0.16, 1, 0.3, 1)";

  return (
    <section
      ref={sectionRef}
      className="relative overflow-hidden py-16 text-white sm:py-20 lg:py-24"
    >
      {/* Fondo con lazy loading */}
      <div
        className="pointer-events-none absolute inset-0 z-0 overflow-hidden opacity-90"
        style={{
          transform: "translateZ(0)",
        }}
      >
        <img
          src="https://res.cloudinary.com/xvzxvfee/image/upload/v1788743200/background1_doxgso.webp"
          alt=""
          loading="lazy"
          decoding="async"
          aria-hidden="true"
          className="h-full w-full object-cover object-center"
        />
      </div>

      <div className="relative z-20 mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
        <div className="pt-4 text-center">
          <div className="relative z-40 mb-10 text-center sm:mb-12">
            <h2 className="mb-4 text-xl font-bold uppercase tracking-[4px] md:text-2xl">
              EXPLORA NUESTROS PROYECTOS
            </h2>
          </div>
        </div>

        <div className="relative isolate grid grid-cols-1 gap-x-8 gap-y-14 sm:gap-y-16 md:grid-cols-2 xl:grid-cols-3">
          {projects.map((project) => {
            const isExpanded = expandedProject === project.id;

            return (
              <div
                key={project.id}
                className="flex w-full items-start justify-center"
              >
                <div
                  ref={isExpanded ? expandedCardRef : null}
                  className={`group relative w-full max-w-[22rem] cursor-pointer sm:max-w-xl lg:max-w-2xl ${
                    isExpanded ? "z-50" : "z-10 hover:scale-[1.02]"
                  }`}
                  onClick={() => toggleProject(project.id)}
                  style={{
                    transition: `transform 500ms ${smoothEase}, opacity 500ms ${smoothEase}`,
                    willChange: "transform",
                  }}
                >
                  <div
                    className="relative"
                    style={{
                      height: isExpanded
                        ? isMobile
                          ? "370px"
                          : "400px"
                        : isMobile
                          ? "250px"
                          : "280px",
                      transition: `height 700ms ${smoothEase}`,
                    }}
                  >
                    <div
                      className="absolute left-0 top-0 w-full overflow-visible"
                      style={{
                        transition: `transform 700ms ${smoothEase}, opacity 500ms ${smoothEase}`,
                      }}
                    >
                      <div
                        className={`relative overflow-visible ${
                          isExpanded
                            ? "scale-[1.02] sm:scale-[1.03]"
                            : "scale-100"
                        }`}
                        style={{
                          transition: `transform 700ms ${smoothEase}, opacity 500ms ${smoothEase}`,
                          willChange: "transform",
                        }}
                      >
                        <div
                          className={`relative rounded-[30px] shadow-2xl ${
                            isExpanded
                              ? "h-[210px] sm:h-[240px] lg:h-[260px]"
                              : "h-[160px] sm:h-[180px] lg:h-[200px]"
                          }`}
                          style={{
                            overflow: "hidden",
                            transform: "translateZ(0)",
                            willChange: "transform",
                            transition: `height 700ms ${smoothEase}, box-shadow 500ms ${softEase}, transform 700ms ${smoothEase}`,
                            WebkitMaskImage:
                              "-webkit-radial-gradient(white, black)",
                          }}
                        >
                          <img
                            loading="lazy"
                            decoding="async"
                            src={project.image}
                            alt={project.title}
                            className={`h-full w-full object-cover ${
                              isExpanded ? "scale-105" : "group-hover:scale-105"
                            }`}
                            style={{
                              transform: isExpanded ? "scale(1.05)" : undefined,
                              transition: `transform 900ms ${smoothEase}, filter 600ms ${softEase}`,
                              willChange: "transform",
                            }}
                          />

                          <div
                            className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/15 to-transparent"
                            style={{
                              transition: `opacity 500ms ${softEase}, transform 700ms ${smoothEase}`,
                            }}
                          />

                          {!isExpanded && (
                            <div
                              className="
                                absolute z-30
                                left-4 top-1/2 -translate-y-1/2
                                sm:left-5
                                lg:left-6
                              "
                              style={{
                                transition: `transform 700ms ${smoothEase}, opacity 450ms ${softEase}`,
                                willChange: "transform",
                              }}
                            >
                              <div
                                className="flex items-center justify-center rounded-[24px] bg-gradient-to-r from-[#D08E00]/70 to-[#6A4800]/70 shadow-[0_14px_34px_rgba(0,0,0,0.35)] backdrop-blur-md w-[72px] h-[118px] sm:w-[90px] sm:h-[138px] lg:w-[100px] lg:h-[152px] opacity-100 transition-all duration-500 group-hover:opacity-85 group-hover:backdrop-blur-lg group-hover:shadow-[0_14px_40px_rgba(0,0,0,0.25)]"
                                style={{
                                  transitionTimingFunction: smoothEase,
                                }}
                              >
                                <span
                                  className="
                                    font-extrabold leading-none text-white
                                    text-[38px]
                                    sm:text-[46px]
                                    lg:text-[52px]
                                  "
                                  style={{
                                    transition: `transform 700ms ${smoothEase}, opacity 450ms ${softEase}`,
                                  }}
                                >
                                  {project.id}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>

                        {!isExpanded && (
                          <div
                            className="px-1 pt-4 sm:px-2 sm:pt-5"
                            style={{
                              transition: `opacity 400ms ${softEase}, transform 500ms ${softEase}`,
                              willChange: "transform, opacity",
                            }}
                          >
                            <h3
                              className="mb-2 text-lg font-bold text-white transition-colors sm:mb-3 sm:text-[24px] lg:text-[26px]"
                              style={{
                                transition: `opacity 400ms ${softEase}, transform 500ms ${softEase}, color 300ms ease`,
                              }}
                            >
                              {project.title}
                            </h3>
                            <p
                              className="max-w-[95%] text-xs leading-relaxed text-gray-300 sm:text-sm lg:text-[15px]"
                              style={{
                                transition: `opacity 400ms ${softEase}, transform 500ms ${softEase}, color 300ms ease`,
                              }}
                            >
                              {project.description}
                            </p>
                          </div>
                        )}

                        {isExpanded && (
  <div
    className="
      absolute left-1/2 top-full z-40
      w-[92%] -translate-x-1/2 -translate-y-[42%]
      sm:w-[88%]
      lg:w-[86%]
    "
    style={{
      transition: `opacity 550ms ${softEase}, transform 700ms ${smoothEase}`,
      willChange: "transform, opacity",
    }}
  >
    <div
      className="
        overflow-hidden
        rounded-[26px]
        border border-white/15
        bg-gradient-to-br
        from-[#D08E00]/80
        via-[#9B6800]/70
        to-[#3D2900]/85
        shadow-[0_24px_70px_rgba(0,0,0,0.45)]
        backdrop-blur-xl
      "
      style={{
        transition: `transform 700ms ${smoothEase}, box-shadow 500ms ${softEase}, opacity 450ms ${softEase}`,
        willChange: "transform, opacity",
      }}
    >
      <div className="p-5 sm:p-6">
        <div className="flex items-start gap-4 sm:gap-5">
          <div
            className="
              flex h-14 w-14 shrink-0 items-center justify-center
              rounded-2xl
              border border-white/20
              bg-white/10
              shadow-[0_8px_24px_rgba(0,0,0,0.20)]
              backdrop-blur-md
              sm:h-16 sm:w-16
            "
          >
            <span
              className="
                text-[24px] font-extrabold leading-none text-white
                sm:text-[30px]
              "
            >
              {project.id}
            </span>
          </div>

          <div className="min-w-0 flex-1 text-left">

            <p
              className="
                text-[13px] leading-relaxed text-white/85
                sm:text-sm
                lg:text-[15px]
              "
            >
              {project.fullDescription || project.description}
            </p>
          </div>
        </div>


        <div className="mt-5">
          <a
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="
              group/btn

              flex w-full
              items-center justify-center gap-2

              rounded-2xl

              border border-white/20
              bg-white/10

              px-5 py-3.5

              text-xs font-bold
              uppercase tracking-[0.18em]
              text-white

              backdrop-blur-md

              transition-all duration-300

              hover:border-white/40
              hover:bg-white
              hover:text-[#6A4800]
              hover:shadow-[0_12px_30px_rgba(0,0,0,0.25)]

              sm:text-[11px]
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="
                h-4 w-4 shrink-0
                transition-transform duration-300
                group-hover/btn:scale-110
              "
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
              <circle cx="12" cy="12" r="3" />
            </svg>

            Ver demo

            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="
                h-3.5 w-3.5 shrink-0
                opacity-80
                transition-all duration-300
                group-hover/btn:translate-x-1
                group-hover/btn:-translate-y-0.5
                group-hover/btn:opacity-100
              "
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="7" y1="17" x2="17" y2="7" />
              <polyline points="7 7 17 7 17 17" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
